<section class="composer-grid">
  <mds-grid
    [overrides]="overrides"
    (gridReady)="onGridReady($event)"
    [themeClass]="'ag-theme-material'"
    [sizeColumnsToFit]="false"
    (selectionChanged)="onSelectionChanged()"
    (cellClicked)="onCellClicked($event)"
    class="composer-grid"
    [minHeight]="'100%'"
  ></mds-grid>
</section>
